<template>
  <div class="trigger">
    <div class="select">
      <sis-select
        :options="option"
        class="notification_select"
        :label="translate_name('notification.edit.triggers.trigger')"
        :placeholder="translate_name('notification.edit.triggers.select')"
        v-model="trigger.definition_id"
        @input="select_trigger(trigger)"
        :disable_branch_nodes="true"
        :clearable="false"
        :searchable="false"
      />
    </div>

    <div class="params">
      <div class="bool" v-if="trigger.type == 'bool'">
        <div class="param">
          <sis-select
            :options="[
              {'label': translate_name('notification.edit.triggers.off'), 'id':0},
              {'label': translate_name('notification.edit.triggers.on'), 'id':1}
            ]"
            class="param_select"
            :label="translate_name('notification.edit.triggers.crit')"
            v-model="trigger.params.crit"
            :disable_branch_nodes="true"
            :clearable="false"
            :searchable="false"
            @input="params_normal(trigger)"
          />
        </div>
      </div>

      <div class="num" v-if="trigger.type == 'int' || trigger.type == 'float'">
        <div class="param">
          {{translate_name('notification.edit.triggers.crit')}}:
          <fg-input :type="trigger.type" v-model="trigger.params.crit"/>
          {{trigger.units}}
        </div>
        <div class="param">
          {{translate_name('notification.edit.triggers.normal')}}:
          <fg-input :type="trigger.type" v-model="trigger.params.normal"/>
          {{trigger.units}}
        </div>
      </div>

      <div class="list" v-if="trigger.type == 'list'">

        <div class="param">
          <sis-select
            :options="option_elements"
            class="param_select"
            :label="translate_name('notification.edit.triggers.interface')"
            :placeholder="translate_name('notification.edit.triggers.select')"
            v-model="trigger.params.element"
            :disable_branch_nodes="true"
            :clearable="false"
            :searchable="false"
          />
        </div>
      </div>

    </div>

    <div class="timer">
      <fg-input
        class="notification_timer"
        v-model.number="trigger.params.timer"
        type="number"
        :label="translate_name('notification.edit.triggers.timer')"
        :min="0"
        :max="3600"
        v-if="trigger.time"
        onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
      />
    </div>

    <div class="delete">
      <span class="mdi mdi-delete" @click="delete_trigger()"/>
    </div>

  </div>

</template>

<script>

export default {
  name: "trigger-item",
  props: [
    'trigger',
    'option',
    'trigger_key',
    'elements'
  ],

  data () {
    return {
      option_elements: []
    }
  },
  created(){
    this.check_item()
  },
  updated(){
    this.check_item()
  },
  watch:{
    elements: function () {
      this.check_item()
    }
  },
  methods : {
    async check_item(){
      if (this.trigger.type == 'list'){
        if (this.elements[this.trigger.url]) {
          this.option_elements = this.elements[this.trigger.url]
        }else{
          await this.sleep(200);
          this.option_elements = this.elements[this.trigger.url]
          if (this.elements[this.trigger.url]) {

            let elements = []
            for (let element of JSON.parse(JSON.stringify(this.elements[this.trigger.url]))) {
              elements.push(element.id)
            }
            if (elements.indexOf(this.trigger.params.element) == -1) {
              this.trigger.params.element = elements[0]
            }
          }
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    translate_name(val){
      return this.translate(val)
    },
    params_normal(trigger){
      if (!trigger.params.crit) {
        trigger.params.normal = 1
      }else{
        trigger.params.normal = 0
      }
    },

    select_trigger(trigger){
      for (var i in this.option) {
        for (var j in this.option[i].children) {
          if (+this.option[i].children[j].id == trigger.definition_id) {
            trigger.definition_id = +this.option[i].children[j].id
            trigger.block_triggers = this.option[i].children[j].block_triggers
            trigger.block_devices = this.option[i].children[j].block_devices
            trigger.label = this.option[i].children[j].label
            trigger.url = this.option[i].children[j].url
            trigger.type = this.option[i].children[j].type
            trigger.list = this.option[i].children[j].list

            trigger.time = (this.option[i].children[j].time) ? this.option[i].children[j].time : true
            trigger.units = (this.option[i].children[j].units) ? this.option[i].children[j].units : ''
            trigger.max = (this.option[i].children[j].max) ? this.option[i].children[j].max : 1000
            trigger.min = (this.option[i].children[j].min) ? this.option[i].children[j].min : -1000

            if (trigger.type == 'list' && !trigger.params.element){
              trigger.params.element = this.elements[trigger.url][0].id
            }
          }
        }
      }
    },
    delete_trigger(){
      this.$emit('delTrigger', this.trigger_key)
    }
  }

}
</script>

<style lang="scss">

.trigger{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  color: #66615b;
  font-weight: bold;
  text-align: center;
  text-align: left;
  font-size: 10px;
  padding: 25px 10px 20px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .select{
    width: 30%;
    .notification_select{
      margin: 0 auto;
      width: 100%;
      position: relative;
      &>label{
        position: absolute;
        top: -20px;
      }
    }
  }
  .params{
    width: 30%;
    .param{
       height: 45px;
       margin: 5px 0;
       display: flex;
       align-items: center;
       justify-content: space-around;
       input{
         margin-top: 1px;
         margin-bottom: 0;
         height: 30px;
         display: inline-block;
       }
       .form-group{
         margin: 0;
       }
       &_select{
         position: relative;
         &>label{
           position: absolute;
           top: -20px;
           margin: 0;
         }
       }
    }
    .bool{
      display: flex;
      justify-content: space-around;
      .param{
        label{
          // margin: 0 10px;
        }
      }
    }
    .list{
      display: flex;
      justify-content: space-around;
      .param{
        label{
          // margin: 0 10px;
        }
      }
    }
    .num{
      .param{
      }
    }
  }
  .timer{
    width: 30%;
    .notification_timer{
      position: relative;
      margin: 0 auto;
      label{
        position: absolute;
        top: -20px;
      }
    }
    input{
      margin-top: 1px;
      margin-bottom: 0;
    }
  }
  .delete{
    width: 4%;
    span{
      font-size: 25px
    }
  }
}

@media (max-width: 700px) {
  .notification_triggers{
    .trigger{
      flex-wrap: wrap;
      .select{
        width: 100%;
        margin-bottom: 20px;
      }
      .params{
        width: 100%;
        margin-bottom: 20px;
      }
      .timer{
        width: 100%;
        margin-bottom: 20px;
      }
      .delete{
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }
}

</style>
